import React, {useEffect, useState} from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import {useNavigate,Link} from "react-router-dom";
import axios from "axios";
import {defaultVariables} from "../../../config";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@mui/material/Grid2";
import AdminDashSkeleton from "../../components/loaders/AdminDashSkeleton";
import {useTranslation} from "react-i18next";
import {Box, IconButton, Typography} from "@mui/material";
import {
    Badge,
    CircleArrowRight,
    ClipboardList,
    CreditCard,
    Eye,
    Loader,
    MessageCircle, MessageSquare,
    MoveRight,
    Store
} from "lucide-react";
import {currencySymbol, price, scrollTop, truncate} from "../../../config/values";
import { LineChart } from '@mui/x-charts/LineChart';
import moment from "moment";
import SwiperSlider from "../../components/elements/slider/SwiperSlider";
import SubTitle from "../../components/elements/SubTitle";
import Title from "../../components/elements/Title";
import StockPriceChart from "../manage/stocks/price/StockPriceChart";
import ProfitsChart from "../manage/stocks/profits/ProfitsChart";
import clsx from "clsx";
import {getDirection} from "../../../config/design/theme";

const AdminDashboard = ({ classes,user,setting }) => {
    const { t } = useTranslation();
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([]);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/dashboards/get-admin`,config)
            .then(response => {
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
        scrollTop();
    }, []);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('dashboard')}>
            <Grid container spacing={2} justify="center" className="dashboard">
                {
                    loading ?
                        <AdminDashSkeleton/>
                        :
                        <>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/bs-requests/view-all'>
                                    <ClipboardList className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center">{t('pending_requests')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_requests}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/installments/view-all'>
                                    <Loader className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('pending_installments')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_installments}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/installments/view-all'>
                                    <CreditCard className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('not_paid_installments')}</span>
                                    <strong style={{fontSize:20}}>{data.not_paid_installments}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/manage/support'>
                                    <MessageSquare className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('unread_tickets')}</span>
                                    <strong style={{fontSize:20}}>{data.unread_tickets}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,md:6}} className="bg-gray-box p-20">
                                <SubTitle><strong>{t('todayStocksPrice')}</strong></SubTitle>
                                <div className="flex-direction gap-0 flex-column-xs">
                                    <Box className="text-center stock-box">
                                        <Title>{t('normal')}</Title>
                                        <strong style={{fontSize:20}}>{price(setting.current_normal_price)} {currencySymbol}</strong>
                                    </Box>
                                    <Box className={clsx('text-center','stock-box', getDirection() === "rtl" ? 'brd-right' : 'brd-left')}>
                                        <Title>{t('special')}</Title>
                                        <strong style={{fontSize:20}}>{price(setting.current_special_price)} {currencySymbol}</strong>
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item size={{xs:12,md:6}}  className="bg-gray-box p-20">
                                <SubTitle style={{marginBottom:20}}><strong>{t('mostStockHolders')}</strong></SubTitle>
                                {
                                    data.stockholders.map((user,index) => (
                                        <Box key={index} className="flex-space" style={{background: "#e9eae9", padding:10, marginBottom:5 ,borderRadius:8}}>
                                            <div className="d-flex" style={{gap:10, minWidth:200}}>
                                                <Typography className='font-12 color-gray-number' style={{backgroundColor:"#fff"}}>{index+1}</Typography>
                                                <Typography className="font-13">{truncate(user.first_name + " " + user.last_name , 18)}</Typography>
                                            </div>
                                            <Typography className="font-13">{user.normal_stocks_count} {t('normal')}</Typography>
                                            <Typography className="font-13">{user.special_stocks_count} {t('special')}</Typography>
                                        </Box>
                                    ))
                                }
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <Box className="bg-gray-box chart">
                                    <SubTitle style={{marginBottom:20}}><strong>{t('stockProfitChart')}</strong></SubTitle>
                                    <ProfitsChart manage/>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <Box className="bg-gray-box chart">
                                    <SubTitle style={{marginBottom:20}}><strong>{t('stockPriceChart')}</strong></SubTitle>
                                    <StockPriceChart/>
                                </Box>
                            </Grid>


                        </>


                }
            </Grid>
        </AppAnimate>

    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mstp)(AdminDashboard));
